import loader from '../../common/loader';
import { loginCookie } from '../login/common';
var jsApi = 'https://jsapi.qq.com/get?api=login.showLoginPanel,login.getAccountInfo';
var qqAppid = '100446242';
var wxAppid = 'wx64f9cf5b17af074d';
var miloSelfConfig = {
  isMiloWayCookies: false,
  appName: 'qb'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve, reject) {
    if (typeof browser !== 'undefined') {
      console.log('has Jsbridge');
      resolve(browser);
      return;
    }

    loader.loadScript({
      url: jsApi,
      sRefresh: 0
    }).then(function (isLoad) {
      if (isLoad && typeof browser !== 'undefined') {
        resolve(browser);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    console.log('login');

    var succCB = function succCB(params) {
      console.log('success CB');
      console.log(params);
      location.reload();
    };

    var errCB = function errCB(err) {
      console.log('拉起登录框失败', err);
    };

    JsBridge.login.showLoginPanel(succCB, errCB);
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loginByQQAndWX();
};

var loginByQQ = function loginByQQ() {
  loginByQQAndWX();
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve, reject) {
    loadJsApi().then(function (JsBridge) {
      var succCB = function succCB(params) {
        console.log('success CB - SetCookie');
        console.log(params);

        if (params && params.type) {
          var logintype = params.type;

          if (logintype == 1 && params.uin && params.skey) {
            loginCookie.setQQ({
              uin: params.uin,
              skey: params.skey
            }, 7200);
          }

          if (logintype == 2 && params.uin && params.token) {
            loginCookie.setQQ({
              acctype: 'wx',
              appid: wxAppid,
              openid: params.uin,
              access_token: params.token
            }, 7200);
          }

          if (logintype == 4 && params.uin && params.token) {
            window.iUseQQConnect = 1;
            loginCookie.setLocal({
              acctype: 'qc',
              appid: qqAppid,
              openid: params.uin,
              access_token: params.token
            }, 7200);
          }

          resolve();
        } else {
          reject();
        }
      };

      var errCB = function errCB(err) {
        console.log(err);
        reject();
      };

      JsBridge.login.getAccountInfo(succCB, errCB);
    })["catch"](function () {
      reject();
    });
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    loadJsApi().then(function (JsBridge) {
      var succCB = function succCB(params) {
        console.log('success CB');
        console.log(params);

        if (params && params.type) {
          var logintype = params.type;

          if (logintype == 1) {
            resolve('pt');
          } else if (logintype == 2) {
            resolve('wx');
          } else if (logintype == 4) {
            resolve('qc');
          } else {
            console.log('no tencent logintype');
            resolve(null);
          }
        } else {
          console.log('no logintype params');
          resolve(null);
        }
      };

      var errCB = function errCB(err) {
        console.log('err', err);
        resolve(null);
      };

      JsBridge.login.getAccountInfo(succCB, errCB);
    })["catch"](function (e) {
      console.log('err', e);
      resolve(null);
    });
  });
};

var logout = function logout() {
  loadJsApi().then(function (JsBridge) {
    console.log('logout');

    var succCB = function succCB(params) {
      console.log('success CB');
      console.log(params);
    };

    var errCB = function errCB(err) {
      console.log('拉起登录框失败', err);
    };

    JsBridge.login.showLoginPanel(succCB, errCB);
  })["catch"](function () {});
};

var qb = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default qb;